import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from '../../layouts/MenuVertical';
import { Icon } from "semantic-ui-react";
import moment from 'moment';
import api from "../../../api";

const DashboardCondominio = ({ match }) => {
  const [loading, setLoading] = useState(true);
  const [condominio, setCondominio] = useState({});
  const [errors, setErrors] = useState({});
  const [votacoes, setVotacoes] = useState(null);
  const [resumo, setResumo] = useState(null);

  useEffect(
    () => {
      const init = async () => {
        try {
          setCondominio(await api.condominio.findSimpleById(match.params.id));
          setLoading(false);
          try {
            setResumo(await api.votacao.resumoParticipacao(match.params.id));
          } catch (e) {
            setResumo(null);
          }
          try {
            const res = await api.votacao.find(match.params.id);
            setVotacoes(res.votacoes || []);
          } catch (e) {
            setVotacoes([]);
          }
        } catch (e) {
          setErrors((e.data && e.data.errors) || {});
        }
      };
      init();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const isCondominioInativo = () =>
    condominio._id && (!condominio.dataVencimento || moment(condominio.dataVencimento) < moment());

  const isRenovacao = () =>
    isCondominioInativo() && condominio.dataPagamento && condominio.dataVencimento;

  return (
    <div>
      {(!!errors.global) && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} loading={loading} />
        {isCondominioInativo() && (
          <section className="va-ativacao" aria-label={isRenovacao() ? "Renovar plano" : "Ativar condomínio"}>
            <div className="va-ativacao-icone"><Icon name={isRenovacao() ? "refresh" : "rocket"} /></div>
            <div className="va-ativacao-texto">
              <h3>
                {isRenovacao()
                  ? "Seu plano venceu. Renove para continuar votando"
                  : "Ative seu condomínio para começar a criar votações"}
              </h3>
              <p>
                {isRenovacao()
                  ? `Vencimento em ${moment(condominio.dataVencimento).format('DD/MM/YYYY')}. A renovação libera novamente as votações e o aplicativo dos moradores.`
                  : "Escolha um plano, informe a quantidade de unidades votantes e pague por PIX ou boleto. A liberação é rápida."}
              </p>
              <ul className="va-ativacao-itens">
                <li><Icon name="check circle" /> Assembleias ilimitadas</li>
                <li><Icon name="check circle" /> Aplicativo de votação</li>
                <li><Icon name="check circle" /> PIX com liberação em minutos</li>
              </ul>
            </div>
            <Link to={`/condominios/${condominio._id}/comprar`} className="va-ativacao-botao">
              {isRenovacao() ? "Renovar agora" : "Ativar agora"} <Icon name="arrow right" />
            </Link>
          </section>
        )}
        {!loading && condominio._id && (
          <>
            <section className="va-dash-hero">
              <div>
                <span className="va-dash-saudacao">Visão geral</span>
                <h1>{condominio.nome}</h1>
              </div>
              {!isCondominioInativo() && (
                <div className="va-dash-acoes">
                  <Link to={`/condominios/${condominio._id}/votacoes/cadastrar`} className="ui button btn-ui-1">
                    <Icon name="plus" /> Nova votação
                  </Link>
                  <Link to={`/condominios/${condominio._id}/unidades/cadastrar`} className="ui button btn-ui-1 btn-ui-1-basic">
                    <Icon name="home" /> Cadastrar unidade
                  </Link>
                </div>
              )}
            </section>

            <section className="va-dash-kpis">
              <div className="va-kpi">
                <span className="va-kpi-icone"><Icon name="home" /></span>
                <div>
                  <small>Unidades votantes</small>
                  <b>{condominio.countUnidades}<em> / {condominio.totalUnidades}</em></b>
                  <div className="va-kpi-barra"><i style={{ width: `${condominio.totalUnidades ? Math.min(100, (condominio.countUnidades * 100) / condominio.totalUnidades) : 0}%` }} /></div>
                </div>
              </div>
              <div className="va-kpi">
                <span className="va-kpi-icone"><Icon name="calendar alternate outline" /></span>
                <div>
                  <small>Vencimento do plano</small>
                  <b className={isCondominioInativo() ? 'alerta' : ''}>{condominio.dataVencimento ? moment(condominio.dataVencimento).format('DD/MM/YYYY') : 'Não ativado'}</b>
                  {condominio.dataVencimento && (
                    <span className="va-kpi-nota">
                      {isCondominioInativo() ? 'Vencido' : `${moment(condominio.dataVencimento).diff(moment(), 'days')} dias restantes`}
                    </span>
                  )}
                </div>
              </div>
              <div className="va-kpi">
                <span className="va-kpi-icone"><Icon name="check square outline" /></span>
                <div>
                  <small>Votações</small>
                  <b>{votacoes === null ? '-' : votacoes.length}</b>
                  <span className="va-kpi-nota">
                    {votacoes === null ? '' : `${votacoes.filter(v => v.votacaoIniciada && !v.votacaoFinalizada).length} em andamento`}
                  </span>
                </div>
              </div>
              <Link to={`/condominios/${condominio._id}/unidades`} className={`va-kpi va-kpi-link ${resumo && resumo.bloqueadas > 0 ? 'atencao' : ''}`}>
                <span className="va-kpi-icone"><Icon name="ban" /></span>
                <div>
                  <small>Unidades bloqueadas</small>
                  <b>{resumo ? resumo.bloqueadas : '-'}</b>
                  <span className="va-kpi-nota">
                    {resumo ? (resumo.bloqueadas > 0 ? 'Não podem votar. Revise na lista de unidades' : 'Todas as unidades estão habilitadas') : ''}
                  </span>
                </div>
              </Link>
              <Link
                to={resumo && resumo.ultimaVotacao ? `/condominios/${condominio._id}/votacoes/editar/${resumo.ultimaVotacao._id}/relatorios` : `/condominios/${condominio._id}/votacoes`}
                className={`va-kpi va-kpi-link ${resumo && resumo.ultimaVotacao && resumo.ultimaVotacao.ausentes > 0 ? 'atencao' : ''}`}
              >
                <span className="va-kpi-icone"><Icon name="chart pie" /></span>
                <div>
                  <small>Participação na última votação</small>
                  {resumo && resumo.ultimaVotacao ? (
                    <>
                      <b>{Number(resumo.ultimaVotacao.participacao).toFixed(0)}%</b>
                      <span className="va-kpi-nota">
                        {resumo.ultimaVotacao.participaram} votaram · {resumo.ultimaVotacao.ausentes} ausente{resumo.ultimaVotacao.ausentes !== 1 && 's'}
                        {resumo.ultimaVotacao.impedidas > 0 ? ` · ${resumo.ultimaVotacao.impedidas} impedida${resumo.ultimaVotacao.impedidas !== 1 ? 's' : ''}` : ''}
                      </span>
                    </>
                  ) : (
                    <>
                      <b>-</b>
                      <span className="va-kpi-nota">Nenhuma votação realizada ainda</span>
                    </>
                  )}
                </div>
              </Link>
            </section>

            <h2 className="va-dash-titulo">Acesso rápido</h2>
            <section className="va-dash-atalhos">
              {[
                ['unidades', 'home', 'Unidades votantes', 'Cadastre, edite e bloqueie unidades'],
                ['responsaveis', 'group', 'Proprietários', 'Dados e contato dos responsáveis'],
                ['votacoes', 'calendar check', 'Votações', 'Crie assembleias, pautas e relatórios'],
                ['notificacoes', 'alarm', 'Convocação digital', 'Envie convocações e avisos por e-mail'],
                ['importacao', 'file excel', 'Importação de arquivo', 'Cadastre unidades por XLS, XLSX ou CSV'],
                ['historico', 'clipboard list', 'Histórico de pagamentos', 'Cobranças e extrato do plano'],
              ].map(([rota, icone, titulo, descricao]) => (
                <Link key={rota} to={`/condominios/${condominio._id}/${rota}`} className="va-atalho">
                  <span className="va-atalho-icone"><Icon name={icone} /></span>
                  <span className="va-atalho-texto"><b>{titulo}</b><small>{descricao}</small></span>
                  <Icon name="chevron right" className="va-atalho-seta" />
                </Link>
              ))}
              <Link to={`/condominios/editar/${condominio._id}`} className="va-atalho">
                <span className="va-atalho-icone"><Icon name="pencil" /></span>
                <span className="va-atalho-texto"><b>Dados do condomínio</b><small>Nome, endereço e configurações de votação</small></span>
                <Icon name="chevron right" className="va-atalho-seta" />
              </Link>
            </section>

            <h2 className="va-dash-titulo">Votações recentes</h2>
            <section className="va-dash-recentes">
              {votacoes === null && <div className="va-dash-vazio">Carregando...</div>}
              {votacoes !== null && votacoes.length === 0 && (
                <div className="va-dash-vazio">
                  <Icon name="inbox" /> Nenhuma votação criada ainda.
                  {!isCondominioInativo() && <Link to={`/condominios/${condominio._id}/votacoes/cadastrar`}> Criar a primeira</Link>}
                </div>
              )}
              {(votacoes || []).slice(0, 4).map(v => {
                const status = v.votacaoFinalizada
                  ? { texto: 'Finalizada', cls: 'finalizada' }
                  : v.votacaoIniciada
                    ? { texto: 'Em andamento', cls: 'andamento' }
                    : { texto: 'Bloqueada', cls: 'bloqueada' };
                return (
                  <Link key={v._id} to={`/condominios/${condominio._id}/votacoes/editar/${v._id}/sobre`} className="va-recente">
                    <span className={`va-recente-status ${status.cls}`}>{status.texto}</span>
                    <b>{v.titulo}</b>
                    <small>{v.dataInicioReuniao}{v.horarioReuniao ? ` · ${v.horarioReuniao}` : ''}{v.local ? ` · ${v.local}` : ''}</small>
                    <span className="va-recente-pautas">{(v.perguntas || []).length} pauta{(v.perguntas || []).length !== 1 && 's'}</span>
                  </Link>
                );
              })}
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default DashboardCondominio;
